import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';

export const AUTH_STORAGE_KEYS = {
  ED_JWT: 'ED_JWT',
  ED_REFRESH_TOKEN: 'ED_REFRESH_TOKEN'
}

export const AUTH_POPUPS = {
  LOGIN: 'EdLoginPopup',
  FORGOT_PASSWORD: 'EdForgotPasswordPopup'
};

export const AUTH_USER_TYPE = {
  PUBLISHER: ['SDA', 'SA', 'TEACHER', 'SUBSTITUTE_TEACHER'],
  BUYER: ['STUDENT'],
  SUBSTITUTE_TEACHER: 'SUBSTITUTE_TEACHER'
}

export enum API_VARIABLES {
  PHONE_NUMBER = '{phoneNumber}',
  EMAIL = '{email}',
  USERNAME = '{username}',
}

export const AUTH_API = {
  USER_INFO: 'organization/currentUser/roles',
  PASS_RESET_REQUEST: 'user/password-reset',
  RECENT_ACTIVITY: 'user/recentActivity',
  CODE_VALIDATE: 'register/verifyCode',
  PASS_RESET : 'user/resetPassword/verificationId',
  PASS_CHANGE : 'user/changePassword',
  GET_ACCESS_TOKEN : 'login/authorization/accessToken',
  LOGIN: 'auth/oauth/token',
  VALIDATE_USER_REGISTER: '',
  CREATE_USER: 'register/user',
  SEND_PHONE_CODE: 'register/sendSMSVerificationCode',
  RESEND_PHONE_CODE: 'register/resendSMSVerificationCode',
  VALIDATE_PHONE_CODE: 'register/verifyCode',
  VALIDATE_EMAIL_CODE: 'register/verifyUser',
  RESPOND_INVITATION: 'register/invitation/accept-reject',
  RESPOND_SUBSTITUTE_INVITATION: 'content/substituteTeacherInvitation/accept-reject',
  GET_TERMS: 'register/t&c',
  VALIDATE_ZIPCODE: 'address/zipGeocoords',
  GET_COUNTRIES: 'address/countries',
  EXISTS_PHONE_NUMBER: 'phone/availability',
  EXISTS_EMAIL: 'user/email/availability',
  EXISTS_USERNAME: 'user/{username}',
  GET_CATEGORIES: 'content/categories',
  GET_INSTITUTION_TYPES: 'register/organization/types',
  VALIDATE_INSTITUTION_NAME: 'register/organization/exists',
  COMPLETE_USER_INVITATION: 'register/invitation/complete',
  COMPLETE_SUBSTITUTE_INVITATION: 'content/substituteTeacherInvitation/complete',
  GET_INVITATION_BY_HASH: 'register/invitation/{hash}',
  GET_SUBSTITUTE_INVITATION_BY_HASH: 'content/substituteTeacherInvitation/lookup',
  VERIFICATION_PUBLIC_TOKEN: 'login/share?publicToken={publicToken}',
  REFRESH_TOKEN: 'auth/oauth/token'
}

export const COMMONS = {
  RESPONSE_SENT : 'SENT',
  VALIDATE_TIMEOUT : 'EXPIRED_TIME',
  VALIDATE_INVALID : 'INVALID',
  VALIDATE_VALID : 'VALIDATED',
  VALIDATE_MAX_ATTEMPTS : 'MAX_ATTEMPTS_EXCEEDED',
  VALIDATE_ALREADY_VALIDATED : 'ALREADY_VALIDATED'
}

export const AUTH_EVENTS = {
  ON_CHANGE_REGISTER_STEP: 'ON_CHANGE_REGISTER_STEP',
  RESEND_CODE: 'RESEND_CODE',
  RESET_ACCOUNT_INFO_FORM: 'RESET_ACCOUNT_INFO_FORM',
  GET_FORM_BASIC_INFO: 'getFormBasicInfo',
  GET_FORM_ACCOUNT_INFO: 'getFormAccountInfo',
  CONFIRM_TERMS: 'confirmTerms',
  CONFIRM_TERMS_MODAL: 'CONFIRM_TERMS_MODAL'
}

export const PUBLIC_RATE_LIMIT_WAIT_SECONDS = {
  SMS_VERIFICATION: 30,
  REGISTRATION: 15
}

export const USER_TYPE = {
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT'
}
// TODO: See if store this in env vars?
export const CAPTCHA_KEYS = {
  SITE: '6Lc-nNQUAAAAALKtdkXY9Gjba2blynAaYWtjGBz8'
}

export const VERIFY_TYPES = {
  TEXT_MESSAGE: 'TEXT_MESSAGE',
  // CALL: 'CALL'
}

export const PHONE_VERIFY_STATUS = {
  VALIDATED: {status: 'VALIDATED', code: 'auth.register.success.phoneVerified', type:TOAST_TYPES.SUCCESS},
  INVALID: {status: 'INVALID', code: 'auth.register.errors.phoneNoVerified', type:TOAST_TYPES.WARNING},
  EXPIRED_TIME: {status: 'EXPIRED_TIME', code: 'auth.register.errors.phoneCodeExpired', type:TOAST_TYPES.DANGER},
  MAX_ATTEMPTS_EXCEEDED: {status: 'MAX_ATTEMPTS_EXCEEDED', code: 'auth.register.errors.phoneCodeMaxAttemptExceeded', type:TOAST_TYPES.DANGER},
  ALREADY_VALIDATED: {status: 'ALREADY_VALIDATED', code: 'auth.register.success.phoneVerified', type:TOAST_TYPES.SUCCESS}
}

export const INVITATION_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
}

export const SUBSTITUTE_INVITATION_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
}

export const EDUAC_URL = {
  URL: 'www.eduac.com'
}
